import { render, staticRenderFns } from "./CallsWidgetContent.vue?vue&type=template&id=3bdb70b8&scoped=true"
import script from "./CallsWidgetContent.vue?vue&type=script&lang=js"
export * from "./CallsWidgetContent.vue?vue&type=script&lang=js"
import style0 from "./CallsWidgetContent.vue?vue&type=style&index=0&id=3bdb70b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb70b8",
  null
  
)

export default component.exports